import { Injectable, computed, signal } from '@angular/core';
import { APP_VERSION } from '../config/app-version';
import { RELEASE_NOTES, ROADMAP } from './release-notes.data';
import { ReleaseNote, RoadmapItem } from './release-notes.model';

const LAST_SEEN_VERSION_KEY = 'nx.lastSeenVersion';

/**
 * Expõe o changelog e o roadmap do app, e controla o estado de
 * "lido/não lido" da versão atual (usado pelo badge da VersionBar).
 */
@Injectable({ providedIn: 'root' })
export class ReleaseNotesService {
  private readonly _lastSeenVersion = signal<string | null>(this.lerVersaoVista());

  readonly releases: readonly ReleaseNote[] = RELEASE_NOTES;
  readonly roadmap: readonly RoadmapItem[] = ROADMAP;

  readonly hasUnread = computed(() => this._lastSeenVersion() !== APP_VERSION);

  marcarComoLido(): void {
    this._lastSeenVersion.set(APP_VERSION);
    try {
      localStorage.setItem(LAST_SEEN_VERSION_KEY, APP_VERSION);
    } catch {
      // Storage indisponível (modo privado/quota excedida) — não bloqueia a UI
    }
  }

  private lerVersaoVista(): string | null {
    try {
      return localStorage.getItem(LAST_SEEN_VERSION_KEY);
    } catch {
      return null;
    }
  }
}
